export default __webpack_public_path__ + "static/media/organization-color.c4d7c089.svg";